'use client';

import { useIsoLayoutEffect } from '@base-ui/utils/useIsoLayoutEffect';
import { useDisposable } from '@mui/x-internals/useDisposable';
import { useAdapter } from '@mui/x-scheduler-internals/use-adapter';
import { EventCalendarPremiumStore } from "./EventCalendarPremiumStore.mjs";
export function useEventCalendarPremium(parameters) {
  const adapter = useAdapter(parameters.dateLocale);
  const store = useDisposable(() => new EventCalendarPremiumStore(parameters, adapter));
  useIsoLayoutEffect(() => store.updateStateFromParameters(parameters, adapter), [store, adapter, parameters]);
  return store;
}